<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import type { MarkComponentProps } from '@portabletext/svelte';
  import { anchorNavigationStore } from '$lib/stores/anchorNavigation';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';

  const responsiveVars = new ResponsiveVars()
    .addFluid('anchor-offset', toFluidVarInput(35, 35))
    .toCSS();

  // Property custom marks receive from @portabletext/svelte when redered
  export let portableText: MarkComponentProps<{
    anchorId?: string;
    addToAnchorNavigationBar: boolean;
    anchorNavigationBarText?: string;
  }>;

  let el: HTMLSpanElement;

  $: ({ anchorId, addToAnchorNavigationBar, anchorNavigationBarText } = portableText.value);

  onMount(() => {
    if (anchorId && el) {
      anchorNavigationStore.registerAnchor({
        el,
        markKey: portableText.markKey,
        addToAnchorNavigationBar,
        text: anchorNavigationBarText || el.innerText
      });
    }
  });

  onDestroy(() => {
    if (anchorId && el) {
      anchorNavigationStore.removeAnchor(el);
    }
  });
</script>

{#if anchorId}
  <span id={anchorId} class={cx(responsiveVars, 'anchor')} bind:this={el}>
    <slot />
  </span>
{/if}

<style lang="scss">
  .anchor:before {
    content: '';
    display: block;
    position: relative;
    width: 0;
    height: var(--anchor-offset);
    margin-top: calc(-1 * var(--anchor-offset));
  }
</style>
